module.exports = __webpack_public_path__ + "img/medIcon.96056db5.png";